// extracted by mini-css-extract-plugin
export var backdropBlur = "_ld-0";
export var contentCard = "_ld-5";
export var frame = "_ld-2";
export var image = "_ld-4";
export var imagePane = "_ld-3";
export var modal = "_ld-1";